module.exports = __webpack_public_path__ + "img/product-shot_03_loading.983a5e19.jpg";